import { TagContainer } from '../models/container';
import { getEvents } from '../models/helpers';
import { UpdatePrivacySettings } from '@app/core/user/store/actions';

const events = getEvents((action: UpdatePrivacySettings) => [
  {
    type: 'pageview',
    container: TagContainer.Analytics,
    payload: { event: 'force_load', id: '' }
  },
  {
    type: 'pageview',
    container: TagContainer.Media,
    payload: { event: 'force_load', id: '' }
  }
]);

export default events;
